export default __webpack_public_path__ + "static/media/agroconsulting.d95312dc.png";